import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NavbarComponent } from "../navbar/navbar.component";
import { LoginServiceService } from '../service/login-service.service';
import { Router } from '@angular/router';
import { AlertComponent } from '../alert/alert.component';
import { CheckoutPagarmeComponent } from '../checkout-pagarme/checkout-pagarme.component';


interface DispositivoAttributes {
  isMobile: boolean;
}

interface FormLoginAttributes {
  email?: string;
  password?: string;
}

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NavbarComponent, AlertComponent, CheckoutPagarmeComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(CheckoutPagarmeComponent) checkoutComponent !: CheckoutPagarmeComponent;

  public dispositivo: DispositivoAttributes; 
  public loginForm: FormGroup;

  //Variavel para o tipo de alerta
  public alertType: boolean = false;

  constructor( private fb: FormBuilder, private loginService: LoginServiceService, private router: Router){
    this.dispositivo = { isMobile: false }; 

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  public ngOnInit(){
    // this.dispositivo.isMobile = this.platform.is('mobile') || this.platform.is('mobileweb');
    // console.log('Dispositivo:', this.dispositivo);
  }

  public async onSubmit() {
    
      this.loginService.loginCliente(this.loginForm.value.email, this.loginForm.value.password).subscribe((response: any)=> {
        // Salva o token no localStorage
        console.log(response);
        localStorage.setItem('token', response.body.token);
        localStorage.setItem('name', response.body.nome);
        // Redireciona para a tela principal
        this.router.navigate(['/app']);
      }, (error: any) => {

        if(error.status === 301){
          this.checkoutComponent.handleShowModal(this.loginForm.value.email);
        }
        console.log('Error:', error.error.status);
        console.log(error.status);
        this.alertComponent.showAlert(`Erro ao tentar realizar login:${error.error.retorno ? error.error.retorno : error.error.status}`,"error")
       
      })
    
  }

  
}
